<template>
  <el-table ref="table" :class="$style['base-table']" :data="tableData" stripe style="width: 100%" :header-cell-style="{
      background: '#fafafa',
      color: '#333',
      lineHeight: '40px'
    }" :border="border" :row-class-name="rowClassName" :row-key="rowKey" :spanMethod="spanMethod" @selection-change="handleSelectionChange" @expand-change="handleExpandChange">
    <el-table-column v-if="selectType === 'checkbox'" type="selection" width="55" :reserve-selection="true" />
    <el-table-column v-else-if="selectType === 'radio'" label="" width="50">
      <template slot-scope="scope">
        <el-radio v-model="selectId" :label="scope.row[selectKey]" @change="selectRow(scope.row)"></el-radio>
      </template>
    </el-table-column>

    <template v-for="(item, index) in columns">
      <el-table-column v-if="!item.slotName" :key="index" :prop="item.value" :label="item.label" :width="item.width" :type="item.type" :min-width="item.minWidth" :max-width="item.maxWidth" :fixed="item.fixed" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :sort-method="item.sortMethod" :show-overflow-tooltip="item.showOverflowTooltip === undefined ? true : item.showOverflowTooltip">
      </el-table-column>
      <el-table-column v-else :key="index" :label="item.label" :width="item.width" :type="item.type" :min-width="item.minWidth" :max-width="item.maxWidth" :fixed="item.fixed" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :sort-method="item.sortMethod" :show-overflow-tooltip="item.showOverflowTooltip === undefined ? true : item.showOverflowTooltip">
        <template slot-scope="scope">
          <slot :name="item.slotName" :row="scope.row" />
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
// 具体配置可参考element-ui的Table-column Attributes
// interface IColumns {
//   label?: string // 列名
//   value?: string // 取值
//   slotName?: string //自定义slot的名字
//   width?: string | number //列宽
//   minWidth?: string | number
//   maxWidth?: string | number
//   type?: string // 对应列的类型: selection / index / expand
//   fixed?: string | boolean // 列是否固定在左侧或者右侧。 true 表示固定在左侧 true / 'left' / 'right'
//   align?: string //对齐方式 left / center / right
//   headerAlign?: string //表头对齐方式 left / center / right
//   sortable?: boolean | string //对应列是否可以排序 true / false / 'custom'
//   sortMethod?: (a: string, b: string) => void //指定数据按照哪个属性进行排序
//   showOverflowTooltip: boolean
// }
export default {
  name: 'base-table',
  props: {
    border: Boolean,
    // 数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 列配置
    columns: {
      type: Array, // 类型参考 IColumns
      default: () => []
    },
    rowClassName: {
      type: String, // 类型参考 IColumns
      default: ''
    },
    rowKey: {
      type: [Function, String], // 类型参考 IColumns
      default: 'id'
    },
    // 选中的类型：多选checkbox，单选radio
    selectType: {
      type: String,
      default: 'checkbox'
    },
    // 选中数据时使用的属性
    selectKey: {
      type: String,
      default: 'id'
    },
    // 选中的数据都属性集合，和selectKey配合使用，如果selectKey为id，那么selectedKeys为id的集合
    selectedKeys: {
      type: [String, Array],
      default: ''
    }, // 是否显示单选
    spanMethod: {
      type: Function
    }
  },
  data () {
    return {
      selectId: ''
    }
  },
  watch: {
    selectedKeys: {
      handler: function (val) {
        this._$toggleRowSelection(val)
      },
      deep: true
    },
    tableData: {
      handler: function (val) {
        this._$toggleRowSelection(this.selectedKeys)
      },
      deep: true
    }
  },
  methods: {
    _$toggleRowSelection (val) {
      console.log('---val',val)
      if (val !== null && val !== undefined) {
        if (Array.isArray(val)) {
          val.forEach((value) => {
            const row = this.tableData.find(e => e[this.selectKey] === value)

            if (row && this.$refs.table) {
              this.$nextTick(() => {
                this.$refs.table.toggleRowSelection(row, true)
              })
            }
          })
        }else {
          this.selectId = val
        }
      }
    },

    handleSelectionChange (selection) {
      this.$emit('selection-change', selection)
    },

    handleExpandChange (row, expandedRows) {
      this.$emit('expand-change', row, expandedRows)
    },

    toggleRowExpansion (row, expanded) {
      this.$refs.table.toggleRowExpansion(row, expanded)
    },

    selectRow (row) {
      this.$emit('selection-change', row)
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    },
  }
}
</script>

<style module lang="less">
.base-table{
	:global{
    .wt-upload-file {
      line-height: 0;
			margin-top: 0;
			.el-upload-list__item:first-child{
			margin-top: 0;
			}
    }
	}
}

</style>
